export type ChartTone = "success" | "info" | "warning" | "danger" | "default";

export const chartPalette = {
  navy: "#163A5F",
  green: "#116B43",
  blue: "#2471A3",
  amber: "#D68910",
  red: "#A93226",
  grey: "#6B7280",
  lightGrey: "#EEF3F8",
};

export function toneColor(tone?: ChartTone | string): string {
  switch (tone) {
    case "success":
      return chartPalette.green;
    case "info":
      return chartPalette.blue;
    case "warning":
      return chartPalette.amber;
    case "danger":
      return chartPalette.red;
    default:
      return chartPalette.navy;
  }
}

export const defaultChartColors = [
  chartPalette.navy,
  chartPalette.green,
  chartPalette.blue,
  chartPalette.amber,
  chartPalette.red,
  "#5D6D7E",
  "#7D3C98",
  "#148F77",
];